"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownInput = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDropdownInput = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 40px;\n  width: 113px;\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &::before {\n    content: '';\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    top: 3px;\n    right: 15px;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  input {\n    background-color: transparent;\n    border: solid 1px ", ";\n    border-radius: inherit;\n    color: ", ";\n    width: 104px;\n    height: 32px;\n    font-family: ", ";\n    font-size: ", ";\n    padding: 4px 4px 4px 8px;\n    z-index: 2;\n  }\n\n  ul {\n    visibility: ", ";\n    padding: 0;\n    margin: 0;\n    max-height: 152px;\n    overflow: auto;\n    width: 100%;\n    list-style: none;\n    border-radius: 4px;\n    z-index: 1;\n\n    li {\n      padding: 4px 8px;\n      color: ", ";\n      font-size: ", ";\n      background-color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n        cursor: pointer;\n      }\n    }\n  }\n"], ["\n  height: 40px;\n  width: 113px;\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &::before {\n    content: '';\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    top: 3px;\n    right: 15px;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  input {\n    background-color: transparent;\n    border: solid 1px ", ";\n    border-radius: inherit;\n    color: ", ";\n    width: 104px;\n    height: 32px;\n    font-family: ", ";\n    font-size: ", ";\n    padding: 4px 4px 4px 8px;\n    z-index: 2;\n  }\n\n  ul {\n    visibility: ", ";\n    padding: 0;\n    margin: 0;\n    max-height: 152px;\n    overflow: auto;\n    width: 100%;\n    list-style: none;\n    border-radius: 4px;\n    z-index: 1;\n\n    li {\n      padding: 4px 8px;\n      color: ", ";\n      font-size: ", ";\n      background-color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n        cursor: pointer;\n      }\n    }\n  }\n"])), function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.x4;
}, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return (isMenuOpen ? '0 8px 16px 0 rgba(48, 49, 51, 0.1)' : 'none');
}, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return (isMenuOpen ? '"\\e92c"' : '"\\e92a"');
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.md;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Borders.hint;
}, function (_a) {
    var Colors = _a.theme.Colors, isMenuOpen = _a.isMenuOpen;
    return isMenuOpen ? Colors.Typography.primary : Colors.Typography.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.fontFamiily;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return (isMenuOpen ? 'visible' : 'hidden');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.subtle;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.primary;
});
var templateObject_1;
